import { format } from "date-fns"

interface Handoff {
	userName: string
	until: string
}

const firstName = (name: string) => name.trim().split(/\s+/)[0] || name

export function outOfOfficeSuffix(handoff: Handoff) {
	return `${firstName(handoff.userName)} is out of office until ${format(new Date(handoff.until), "d MMM")}.`
}

/** Timeline line for an assignment that skipped someone out of office. */
export function outOfOfficeAssignLine(opts: {
	handoff: Handoff
	actorName: string
	newAssigneeName: string | null
	moved: boolean
}) {
	const suffix = outOfOfficeSuffix(opts.handoff)
	if (!opts.newAssigneeName) return `Unassigned. ${suffix}`
	const to = firstName(opts.newAssigneeName)
	return opts.moved
		? `Moved from ${firstName(opts.handoff.userName)} to ${to}. ${suffix}`
		: `${opts.actorName} assigned ${to}. ${suffix}`
}
